module.exports = __webpack_public_path__ + "static/media/p1_9.561f77b6.png";